import { Outlet } from "react-router";
// import AppLogo from "static/images/FinLogo.png";
import AppLogo from "../../assets/images/finkraftlogo.png";
import "./Auth.scss";
import Typography from "app/shared/Typography";
import { colorPicker } from "app/utils/color.helper";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Avatar } from "antd";
import DoubleQuotes from "static/images/DoubleQuotes.svg";
import CarouselComponent from "./components/slidercontainer/CarouselComponent";
import { getSubdomain } from "app/utils/generic.helper";
export default function Auth(props: any) {
  const subdoman = getSubdomain();
  const staticCDNURL = `https://static-assets.finkraftai.com/logo/${subdoman}.png`;
  return (
    <div className="Auth">
      <div className="Container">
        <div className="LeftContainer">
          <div className="TopLogo">
            <img alt="AppLogo" src={staticCDNURL} />
            {/* <div className="MiniDivder" /> */}
          </div>
          {/* <div className="MetaInfo">
            <Typography
              style={{
                fontSize: 40,
                color: colorPicker("neutral.950"),
                lineHeight: "44px",
              }}
            >
              Start your <br /> journey with us
            </Typography>

           

            <Typography
              style={{
                color: colorPicker("neutral.800"),
                marginTop: 6,
              }}
            >
              Discover the oasis of reconciliation, where efficiency and
              precision converge in perfect equilibrium.
            </Typography>
          </div> */}
          {/* <div className="CarouselContainer">
            <div className="CarouselCard">
              <img
                src={DoubleQuotes}
                alt="doubleQuote"
                className="quoteImage"
              />
              <Typography
                style={{ color: colorPicker("neutral.900"), marginTop: 12 }}
              >
                Krafting a welcoming experience that leaves no room for
                confusion.
              </Typography>

              <div className="UserInfo">
                <Avatar
                  size={52}
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0R5na2w29xsGM_nEpE1eDCJBvyAW3weOhuEirffnyiA&s"
                  style={{
                    borderRadius: 18,
                  }}
                />
                <div className="UserDetails">
                  <Typography>Rohit Anand</Typography>
                  <Typography
                    variant="caption"
                    style={{ color: colorPicker("neutral.700") }}
                  >
                    Founder of Finkraft.ai
                  </Typography>
                </div>
              </div>
            </div>
            
          </div> */}
          <CarouselComponent />
        </div>
        <div className="RightContainer">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
